import React from 'react';
import { FaArrowLeft, FaLongArrowAltRight, FaPhotoVideo, FaRegWindowMaximize } from 'react-icons/fa';
import { peerlessDataEflyers} from '../Components/PeerlessData';
import Slider from 'react-slick';
import { Tooltip } from 'react-tooltip';

const GraphicDesignPage = ({setNavLinks, handleImageExpansion, slidesToShow1, setSlidesToShow1, sliderState8, setSliderState8, handleAfterChange8}) => {


    
  React.useEffect(() => {
    // retrieve slider state from local storage on component mount
    const storedState = JSON.parse(sessionStorage.getItem('sliderState8'));
    if(storedState){setSliderState8(storedState)}
    const handleResize = () => {
      if (window.innerWidth >= 1030) {
        setSlidesToShow1(6);
      } else if (window.innerWidth >= 600) {
        setSlidesToShow1(5);
      } else if (window.innerWidth >= 300) {
        setSlidesToShow1(2);
      } else {
        setSlidesToShow1(1);
      }

      
    };

    handleResize()
    window.addEventListener('resize', handleResize);
    
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [setSlidesToShow1, setSliderState8]);

    const settings = {

        dots: false,
        Infinity: true,
        slidesToShow: slidesToShow1,
        slidesToScroll: 1,
        lazyLoad: true,
        Speed: 200,
        swipe: true,
        swipeToSlide: true,

       
    }


  return (
    <div className='container-fluid'> 
            <div className='close-window-icon' ><FaArrowLeft color='#1b2328' onClick={()=>{
              
              setNavLinks({serviceLink: true})
              sessionStorage.setItem("currentSession", JSON.stringify({serviceLink: true}));
              }}/> </div>
            <h1 className='title'><FaPhotoVideo color='#1b2328' /> E-Flyers </h1>



             {/* Graphic Design for E-flyers  */}
        <div className="hair-service-container">

                <h1>Slide to see more <FaLongArrowAltRight/></h1>

                <Slider {...settings} afterChange={handleAfterChange8} initialSlide={sliderState8.currentSlide}>

                        {

                        peerlessDataEflyers.map((ourHair)=>{

                            return(
                                    <article className='hair-service-card' key={ourHair.id} > 
                                            
                                            <div className="hair-service-img-container">
                                            <img src={require(`../Images/ServiceImages/${ourHair.folder}/${ourHair.image}`)} alt="Hair Styles"/>
                                            </div>

                                            <div className="hair-service-details">

                                                <p>{ourHair.name} </p>

                                                
                                            </div>
                                            
                                            <div className='enlarge-img-icon' data-tooltip-id='my-tooltip' data-tooltip-content='Expand'>

                                              <Tooltip id='my-tooltip'/>
                                              
                                              <FaRegWindowMaximize onClick={()=>handleImageExpansion(ourHair.id)} color='white'/>
                                              
                                              
                                            </div>
                                            

                                    </article>
                            )

                        })
                        }

                </Slider>
        </div>

        <div className='see-more' onClick={()=>{
          
          setNavLinks({graphicDesignLink1: true})
          sessionStorage.setItem("currentSession", JSON.stringify({graphicDesignLink1: true}));
          }}>
           <p> <FaLongArrowAltRight/> See More Collections</p>
         
        </div>
             
    </div>
  )
}

export default GraphicDesignPage;